import { Navigate } from "react-router-dom";
import { urls } from "../../../urls";

export const ContractSettingsRoute = () => <Navigate to={`${urls.v2.settings}?tab=contract-types`} replace />;
